import React from 'react';
import { connect } from "react-redux";
import { submitRSA } from './../../../actions/crossSellApplicationActions';
import IDVHeader from './../Common/IDVHeader';
import { IDV_HEADER, IDV_SUB_HEADER, IDV_INFO } from './../Constants/labels';
import { rsaDataLayer } from "./../../../analytics/adobe/dataLayerValues";
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "./../../../analytics/adobe/index";
import './rsa.scss';

class Rsa extends React.Component {

    state={
      rsaFields: this.props.data?this.props.data.map(field=>{ return { ...field, ...{ val: '' } }; }):null,
      isContinueButtonEnabled: false,
      btnCheck: this.props.disableContinueBtnPerm?this.props.disableContinueBtnPerm:null
    };

    componentDidMount() {
      const { pageName, siteSection }=rsaDataLayer;
      updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
    }

    componentDidUpdate(prevProps, nextState){
      if(prevProps.data !== this.props.data && this.props.data!==null ){
        this.setState({
          rsaFields: this.props.data?this.props.data.map(field=>{ return { ...field, ...{ val: '' } }; }):null,
          isContinueButtonEnabled: false,
          btnCheck: this.props.disableContinueBtnPerm?this.props.disableContinueBtnPerm:null
        });
      }
    }

    handleInputChange=(textValue, index)=>{
      let updatedField= this.state.rsaFields;
      updatedField[index].val=textValue;
      this.setState({
        rsaFields: updatedField,
        isContinueButtonEnabled: !this.isFormValid(updatedField)
      });
    };

    isFormValid=(data)=>{
      let invalidInput = [...data].filter(v=>v.val.length===0);
      return invalidInput.length > 0;
    };

    handleContinueClick(){
      let rsaAnswers=this.state.rsaFields.map(field=>{
        return {
          questionId: field.questionId,
          answer: field.val
        };
      });
      let formData={};
      formData.clSubmitAnswersRequest={
        verificationContextId: this.props.verificationContextsId,
        answers: rsaAnswers
      };
      //Submit RSA Answers
      this.props.submitRSA(formData, this.props.bankInfo, this.props.challengeType);
    }


    render(){
      const { rsaFields, isContinueButtonEnabled }=this.state;
      let checkDisableBtn = (this.props.disableContinueBtnPerm == "update_power_curve") || (this.props.disableContinueBtnPerm =="approved")?true:!isContinueButtonEnabled;

      return (
        <div className="row">
          <div className="col-xs-12 col-lg-12 col-md-12">
            <IDVHeader title={IDV_HEADER} subHeading={IDV_SUB_HEADER} info={IDV_INFO} />
          </div>
          <div className="col-xs-12 col-lg-12 col-md-12 rsaPage">
            {
              rsaFields&&rsaFields.map((field, index)=>{
                return <div key={`rsa-input-${index}`} className="idv-rsa-wrapper">
                  <p className="standard-blue" aria-label={field.question} id="rsaQuestion">{field.question}</p>
                  <input className="idv-rsa-input standard-blue"
                    type="text"
                    value={field.val}
                    onKeyDown={e=>{
                      if(e.keyCode===13){
                        e.target.blur();
                      }
                    }}
                    onChange={e=>this.handleInputChange(e.target.value, index)}
                    aria-labelledby="rsaQuestion"/>
                </div>;
              })
            }

            <button
              id="rsaBtn"
              data-track="custom-links"
              className={`idv-btn idv-rsa-btn-size ${checkDisableBtn?'rsa-idv-btn-disabled':'button-override-color'}`}
              onClick={e=>this.handleContinueClick()}
              disabled={checkDisableBtn}
              aria-label="click to continue">Continue</button>
          </div>
        </div>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    disableContinueBtnPerm: state.creditCardApplicant.disableContinueBtnPerm
  };
};

const mapDispatchToProps = {
  submitRSA: submitRSA
};

export default connect(mapStateToProps, mapDispatchToProps)(Rsa);
